import request from '@/utils/request'

export function getorder(id) {
    return request.post('/order/getorder', { investId: id });
}

export function syncOrderById(orderNo) {
    return request.get(`/pay/order/sync/${orderNo}`);
}

/**
 * 获取我的订单列表
 * type: PUR：认购，提现：WHC,PCL:充值，PCU:线上充值，PCD：线下充值
 * @param {*} params {pageNum: 1, pageSize: 10, type: 'PUR', beginTime: '2020-03-12 12:00:23', endTime: '2020-03-12 12:00:23'}
 * @returns 
 */
export function getAllOrder(params) {
    return request.post('/order/all', params)
}

/**
 * 撤销提现申请
 * @param {*} orderId 
 * @returns 
 */
export function cancelWithdraw(orderId) {
    return request.post('/pay/cancelWithdraw', { id: orderId })
}
